export default __webpack_public_path__ + "static/media/accountUnverified.09e8f23c.svg";